import MergeClient from "./MergeClient";

export default MergeClient;